export class Info {
    name;
    address;
    area = new Area();
    phone;
    areaStr;
}

export class Area {
    province;
    city;
    country;
}